import { DAYS_PER_MONTH } from 'constants/product/periods';

import { CurrentProduct } from 'types/payments/payments';

export const isOneMonthProduct: ({ period, trial }: Partial<CurrentProduct>) => boolean = ({ period, trial }) =>
    period === trial && period === DAYS_PER_MONTH;
